import React, { FunctionComponent } from 'react';
import { Helmet } from 'react-helmet';
import { Global } from '@emotion/core';

import { LayoutRoot, LayoutMain, globalStyles } from './Layout.style';
import Footer from '../Footer';
import HelfyAdvert from '../HelfyAdvert';

const Layout: FunctionComponent = ({ children }) => (
  <LayoutRoot>
    <Helmet>
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
      <link
        href="https://fonts.googleapis.com/css2?family=IBM+Plex+Sans:ital,wght@0,400;0,500;0,600;0,700;1,400;1,500&family=Poppins:ital,wght@0,400;0,500;0,600;0,700;1,400;1,500&display=swap"
        rel="stylesheet"
      />
      <link rel="apple-touch-icon" sizes="180x180" href="/apple-touch-icon.png" />
      <link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png" />
      <link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png" />
      <link rel="manifest" href="/site.webmanifest" />
      <link rel="mask-icon" href="/safari-pinned-tab.svg" color="#CC5500" />
      <link rel="shortcut icon" href="/favicon.ico" />
      <meta name="msapplication-TileColor" content="#ffffff" />
      <meta name="theme-color" content="#ffffff" />
    </Helmet>
    <Global styles={globalStyles} />
    <LayoutMain>{children}</LayoutMain>
    <HelfyAdvert />
    <Footer />
  </LayoutRoot>
);

export default Layout;
